import { render, staticRenderFns } from "./v-layout.vue?vue&type=template&id=177190c0&scoped=true&"
import script from "./v-layout.vue?vue&type=script&lang=js&"
export * from "./v-layout.vue?vue&type=script&lang=js&"
import style0 from "./v-layout.vue?vue&type=style&index=0&id=177190c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177190c0",
  null
  
)

export default component.exports